import React from "react";

function FooterComponent() {
  return <div>Footer</div>;
}

export default FooterComponent;
